import { useQuery } from '@tanstack/react-query';
import { Preference } from '../../../types/Preference';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchPreference = async (uuid: string) => {
  const response = await CustomAxios.get<Preference>(`preferences/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetPreferenceByIdProps {
  uuid: string;
}
export function useGetPreferenceById({ uuid }: UseGetPreferenceByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allPreferences, uuid],
    queryFn: () => fetchPreference(uuid),
  });

  return query;
}
